import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchLedgers } from "../features/ledgers/ledgerSlice";

//import BuyerForm from "./BuyerForm";
import LedgerTable from "./LedgerTable";

function Ledgers() {

    const dispatch = useDispatch();

    const { loading, error } = useSelector(
        (state) => state.ledgers
    );

    useEffect(() => {

        dispatch(fetchLedgers());

    }, [dispatch]);

    if (loading) {

        return (

            <div className="text-center mt-5">

                <div className="spinner-border text-primary"></div>

            </div>

        );

    }

    if (error) {

        return (

            <div className="alert alert-danger">

                {error}

            </div>

        );

    }

    return (

        <div className="container-fluid mt-3">

            <div className="row">

                <div className="col-lg-12">

                    <LedgerTable />

                </div>

            </div>

        </div>

    );

}

export default Ledgers;